export default __webpack_public_path__ + "static/widget-no-image-ad1dee59e54630baaac458e9f492d2b8.png";